import Vue from 'vue'
import VueRouter from 'vue-router'

import store from './store/index.js'

import { routes } from './routes'

Vue.use(VueRouter);

let router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  var re = /\/reset\/[abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-_]+/
  if (to.name !== 'login' && to.path !== '/offline' && to.name !== 'requestReset' && re.test(to.path) === false) {
    if (store.state.isLoggedIn) {
      next()
    } else {
      next('login')
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./WebApp/router.js